export const environment = {
  production: true,
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  dataServiceUrl: 'https://api-bb-test.internal.sparbankensyd.se/api',
  bankIdUrl: 'https://cu.test.bankid.com/list-and-revoke-v1/?sst=',
  domain: 'bb-stage.internal.sparbankensyd.se'
}
